import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs';
import { RepoBusiness, RepoContact } from '../../models/repo-business/repo-business.model';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { RepoBusinessService } from '../../shared-new/services/repo-business.service';
import { RepoBusinessFacade } from '../../shared-new/store/repo-business/repo-business.facade';
import { RepocontactEditComponent } from '../repocontact-edit/repocontact-edit.component';

@Component({
  selector: 'app-repo-contact-org-popup',
  templateUrl: './repo-contact-org-popup.component.html',
  styleUrls: ['./repo-contact-org-popup.component.scss']
})
export class RepoContactOrgPopupComponent extends BaseUnsubscribeComponent implements OnInit {
  @Input() isViewMode: boolean = true;
  @Input() business: RepoBusiness;
  @Input() contactId: number = 0;
  contacts: RepoContact[] = [];
  contact: RepoContact = {} as RepoContact;
  @ViewChild('repoContactEdit') repoContactEdit: RepocontactEditComponent;
  public searchTerm: string = '';
  constructor(private readonly repoBusinessFacade: RepoBusinessFacade, public readonly modal: NgbActiveModal, private readonly repoBusinessService: RepoBusinessService) {
    super();
  }

  public contactSaved(contact: RepoContact): void {
    if (this.contactId === 0) {
      this.isViewMode = true;
    } else {
      this.dismissPopup();
    }
   
  }
  public dismissPopup(): void {
    this.modal.dismiss(JSON.stringify(this.business));
  }
  public AddContact() {
    if (this.contactId === 0) {
      this.isViewMode = false;
      this.contact = {
        repoContactId: 0, repoBusiness: { repoBusinessId: this.business?.repoBusinessId }
      } as RepoContact;
    } else {
      this.repoBusinessService.getContactById(this.contactId).pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
        this.isViewMode = false;
        this.contact = response;
      });
    }
  }
  public contactValidationFailed(contact: RepoContact) {
  }
  public cancelPopup() {
    if (this.contactId === 0) {
      this.isViewMode = true;
    } else {
      this.dismissPopup();
    }
  }
  public EditRepoContact(contact: RepoContact) {
    this.repoBusinessService.getContactById(contact.repoContactId).pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      this.isViewMode = false;
      this.contact = response;
    });
  }
  ngOnInit(): void {
    this.repoBusinessFacade.contactsByBusinessId$(this.business.repoBusinessId).pipe(takeUntil(this.unsubscribe$)).subscribe((contacts) => {
      this.contacts = contacts;
    })
    if (!this.isViewMode) {
      this.AddContact();
    }
  }

  public saveContact(): void {
    this.repoContactEdit?.submitForm();
  }

}
